import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_HEIGHT_MEDIUM,
} from 'client/components/SrButton/SrButton';

const SrFooterSaveButton = ({ isSubmitting, buttonText, onClick, type }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrButton
      theme={SR_BUTTON_THEME_ADOBE_GREEN}
      minWidth={isSmallScreen ? '100%' : '130px'}
      heightType={SR_BUTTON_HEIGHT_MEDIUM}
      hasBoxShadow
      disabled={isSubmitting}
      type={type}
      onClick={onClick}
    >
      {buttonText || (isSubmitting ? 'Saving...' : 'Save')}
    </SrButton>
  );
};

SrFooterSaveButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
  isSubmitting: PropTypes.bool,
  buttonText: PropTypes.string,
};

SrFooterSaveButton.defaultProps = {
  type: 'submit',
};

SrFooterSaveButton.displayName = 'SrFooterSaveButton';

export default SrFooterSaveButton;
